export default {
    init() {

        const controls = document.querySelectorAll(".js-quantity-control");

        controls.forEach(control => {

            const input = control.querySelector(".js-quantity-input");
            const incrementBtn = control.querySelector(".js-increment-quantity");
            const decrementBtn = control.querySelector(".js-decrement-quantity");

            incrementBtn.addEventListener("click",  event => {
                input.stepUp();

                event.preventDefault();
            });

            decrementBtn.addEventListener("click",  event => {
                input.stepDown();

                event.preventDefault();
            });
        });
    }
}
